import { CloseIcon } from "../../assets/icons/icons";
import "./pillar.css";

const extractTag = (text, tag) => {
    const regex = new RegExp(`<${tag}>(.*?)<\\/${tag}>`, "gs");
    const matches = text?.matchAll(regex);
    if (!matches) return [];
    return Array.from(matches).map(match => match[1].trim());
};

const PillarInfoModal = ({ isOpen, closeModal, pillarData }) => {
    if (!isOpen) return null;
    console.log("pillarData in modal", pillarData);

    const headers = extractTag(pillarData.pillar_description, "header");
    const paragraphs = extractTag(pillarData.pillar_description, "p");

    // Skip the first header (it's the title, already shown in modal header)
    const subHeaders = headers.slice(1);

    // If there are subheaders, pair them with paragraphs
    // If no subheaders, just display paragraphs
    const hasSubHeaders = subHeaders.length > 0;

    return (
        <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{pillarData.pillar_name}</h2>
                    <CloseIcon onClick={closeModal} className="cancel-icon" />
                </div>

                <div className="instructions-body">
                    <div className="tool-tip-container">
                        {hasSubHeaders ? (
                            // Display subheaders with their paragraphs
                            subHeaders.map((header, index) => (
                                <div key={index}>
                                    <h3>{header}</h3>
                                    <p className="tool-tip-text">{paragraphs[index]}</p>
                                </div>
                            ))
                        ) : (
                            // Display paragraphs directly without subheaders
                            paragraphs.map((paragraph, index) => (
                                <p key={index} className="tool-tip-text">{paragraph}</p>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PillarInfoModal;